<template>
<div>
  <div class="card-page-container alert"  >
    <div class="mdl-grid">
      <div class="mdl-layout-spacer"></div>
      <div class="mdl-cell fill mdl-shadow--2dp">
        <alert title="payment.label.title" message="payment.label.success" goto="/"></alert>
      </div>
      <div class="mdl-layout-spacer"></div>
    </div>
  </div>
  <div v-if="step === 1">
    <div class="mdl-grid card-page-container">
      <div class="mdl-card mdl-cell mdl-cell--12-col mdl-shadow--2dp">
        <h3 class="mdl-dialog__title"></h3>
        <div class="mdl-dialog__content">
          <p>
            {{ 'subscription.message.success.title'  | label }}
            <!-- {{ 'subscription.message.success.keep' | label }}} -->
          </p>
        </div>
        <div class="mdl-dialog__actions">
          <div class="mdl-button mdl-js-button mdl-button--colored"><a v-link="{path: '/app/managed'}">{{ 'subscription.button.dialog.keep' | label}}</a></div>
          <div class="mdl-button mdl-js-button mdl-button--colored"
              v-on:click="deleteOldMessages()">{{ 'subscription.button.dialog.delete' | label}}</div>
        </div>
      </div>
    </div>
  </div>
</div>  
</template>

<script>
var local = require('common/store/local')
var api = require('api')
var getters = require('common/store/getters')
module.exports = {
  ready: function () {
    var self = this
    var auth = local.get('client.auth')
    if (auth) {
      self.step = 1
    }
  },
  vuex: {
    getters: getters
  },
  methods: {
    deleteOldMessages: function () {
      var self = this
      this.success = false
      this.$dispatch('loading', true)
      api.Message.deleteAll({userId: this.user.id}).then(function () {
        self.$dispatch('loading', false)
        self.$route.router.go('/app/managed')
      }, self.onError)
    }
  },
  components: {
    alert: require('c/components/Alert')
  },
  data: function () {
    return {
      step: 0
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// BCSuccess.vue?04a3acd4